import { useEffect, useRef, useState } from "react";
import { DropSelector } from "../components/dropDown";
import { Header } from "../components/header";
import { Wrapper } from "../components/wrapper";
// Import useTranslation hook
import { useTranslation } from '../i18n/useTranslation';
// Adjust imports from textconstants.js based on what you kept
import { Constants } from "../constants/textconstants"; // Only import what's still a true constant
import { useDispatch, useSelector } from "react-redux";
import { SearchableModal } from "./searchableModal";
import { fetchAllRetailers } from "../store/slices/retailersList";
import { Styles } from "../styles/headerwithSearch";
import { WrapperRow } from "../components/WrapperRow";
import { RetailersList } from "../components/retailersList";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Loader } from "../components/loader";
import { NotAuthorized } from "../components/notAuthorized"; // This component itself needs to be updated to use t()
import { NoStores } from "../components/noSTorsfound"; // This component itself needs to be updated to use t()
import { useQueryParams } from "../hooks/useQueryParams";

export const Home = () => {
  const queryParams = useQueryParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataSelector, setDataDelector] = useState({
    fot: false,
    subdist: false,
  });
  const { selectedFOT, selectedSubDist, selectedFOTvalue } = useSelector(
    (state) => state.subDist
  );
  const [searchParams] = useSearchParams();
  const { subdistrict, fot, loading, retailers } = useSelector(
    (state) => state.retailers
  );
  const [filteredSubs, setFilteredSubs] = useState([]);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [parsedParameters, setParsedParameters] = useState({
    territory_id: queryParams.territory_id,
    user_id: queryParams.fo_id,
    fo_phone_number: queryParams.fo_phone_number,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation(); // Initialize useTranslation

  useEffect(() => {
    localStorage.setItem("territory_id", queryParams.territory_id);
    localStorage.setItem("user_id", queryParams.fo_id);
    const handlePopState = () => {
      // Redirect the user to the current page
      navigate(location.pathname, { replace: true });
    };
    // Add a popstate event listener to handle the back button
    window.addEventListener("popstate", handlePopState);
    return () => {
      // Clean up the event listener
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, location.pathname, queryParams.territory_id, queryParams.fo_id]); // Added queryParams to dependency array

  useEffect(() => {
    if (selectedFOTvalue) {
      setFilteredSubs(
        subdistrict.filter((item) => item.relatedFT === selectedFOTvalue)
      );
    }
  }, [selectedFOTvalue, subdistrict]); // Added subdistrict to dependency array

  const handleClick = async (selected) => {
    if (selected === Constants.fot) { // Use Constants.fot as an internal identifier
      setDataDelector({ fot: true, subdist: false });
    } else { // This implies Constants.sub_dist
      setDataDelector({ fot: false, subdist: true });
    }
    setIsModalOpen(true);
  };

  const clearCustomerId = async () => {
    await localStorage.removeItem("customer_id");
    await localStorage.removeItem("mobile_number");
  };

  useEffect(() => {
    clearCustomerId();
  }, []);

  const hasFetched = useRef(false); // Track if data has been fetched

  useEffect(() => {
    if (queryParams.territory_id && queryParams.fo_id) {
      setIsAuthorized(true);
      localStorage.setItem('mobile_number', "");
      localStorage.setItem('brp_mobile_number', "");
      if (parsedParameters["territory_id"] && parsedParameters["user_id"]) {
        // No need to set parsedParameters if they are already coming from queryParams
        // setParsedParameters(parsedParameters); // This line is redundant
      }
      if (!hasFetched.current) { //check if the data is already fetched
        dispatch(fetchAllRetailers(queryParams));
        hasFetched.current = true; //set true after fetching the data
      }
    } else {
      setIsAuthorized(false);
      hasFetched.current = false; //reset the hasFetched value to false if the params are changed
    }
  }, [queryParams, dispatch, parsedParameters]); // Added parsedParameters to dependency array

  return (
    <>
      {!isAuthorized ? (
        // NotAuthorized component needs to use `t()` internally for its message
        <NotAuthorized />
      ) : (
        <div>
          <div style={Styles.fixedContainer}>
            <Header
              isNewSurvay={true}
              header={t('retailer_survey')} // Translate the header
              subheader={""}
              userID={parsedParameters["user_id"]}
              territoryID={parsedParameters["territory_id"]}
            />
            <WrapperRow>
              <Wrapper
                isDisabled={false}
                fieldTag={t('FOT_placeholder')} // Translate fieldTag (e.g., "Select FOT")
                isHalf={true}
              >
                <DropSelector
                  SelectedData={selectedFOT ?? null}
                  placeHolder={t('FOT_placeholder')} // Translate placeholder
                  onPress={() => {
                    handleClick(Constants.fot); // Use Constants.fot as an identifier
                  }}
                />
              </Wrapper>
              <Wrapper
                isDisabled={selectedFOT === null}
                fieldTag={t('sub_dist_placeholder')} // Translate fieldTag (e.g., "Select Sub-District")
                isHalf={true}
              >
                <DropSelector
                  SelectedData={selectedSubDist ?? null}
                  placeHolder={t('sub_dist_placeholder')} // Translate placeholder
                  onPress={() => {
                    handleClick(Constants.sub_dist); // Use Constants.sub_dist as an identifier
                  }}
                />
              </Wrapper>
            </WrapperRow>
          </div>
          {isModalOpen && (
            <SearchableModal
              data={dataSelector.fot ? fot : filteredSubs}
              loading={loading}
              onClose={() => setIsModalOpen(false)}
              texts={{
                placeholder: dataSelector.fot ? t('FOT_placeholder') : t('sub_dist_placeholder'),
                select_all: t('select_all') // Assuming SearchableModal needs this
              }}
            />
          )}
          {loading ? (
            <Loader />
          ) : retailers && retailers.length === 0 ? (
            // NoStores component needs to use `t()` internally for its message
            <NoStores />
          ) : (
            <RetailersList parsedParameters={parsedParameters} />
          )}
        </div>
      )}
    </>
  );
};